if (!customElements.get('slider-with-images')) {
  class SliderWithImages extends HTMLElement {
    constructor() {
      super();
      this.state = {
        isInitialized: false
      };
      this.elements = {
        swiperContainer: this,
        nextButton: this.querySelector('.swiper-button-next'),
        prevButton: this.querySelector('.swiper-button-prev'),
      };

      this.swiperInstance = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      if (this.state.isInitialized) return;
      
      this.elements.swiperContainer = this;
      if (!this.elements.swiperContainer) return;

      const slides = this.elements.swiperContainer.querySelectorAll('.swiper-slide');
      console.log(slides);
      if (slides.length <= 1) return;

      this.initSwiper();
      this.state.isInitialized = true;
    }

    initSwiper() {
      const useAdaptiveRatio = this.dataset.originAdaptiveRatio === 'true';

      this.elements.swiperInstance = new Swiper(this.elements.swiperContainer, {
        loop: false,
        centeredSlides: false,
        slidesPerView: useAdaptiveRatio ? 'auto' : 1.145,
        spaceBetween: 16,
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16,
        navigation: {
          nextEl: this.elements.nextButton,
          prevEl: this.elements.prevButton,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: window.accessibilityLabels.slider.previousSlide,
          nextSlideMessage: window.accessibilityLabels.slider.nextSlide,
          firstSlideMessage: window.accessibilityLabels.slider.firstSlide,
          lastSlideMessage: window.accessibilityLabels.slider.lastSlide,
        },
        breakpoints: {
          992: {
            slidesPerView: useAdaptiveRatio ? 'auto' : 1.216,
            spaceBetween: 32,
            slidesOffsetBefore: 0,
          }
        }
      });
    }

    destroy() {
      if (this.elements.swiperInstance) {
        this.elements.swiperInstance.destroy(true, true);
        this.elements.swiperInstance = null;
      }
      this.state.isInitialized = false;
    }
  }

  customElements.define('slider-with-images', SliderWithImages);
}
